.aj{flex:1;}